import {http} from '@/http'

const resource = "/api/projects";

export default {
    getAllProjects(user_id) {
        return http.get(`${resource}/user/${user_id}`)
    },
    updateProject(payload) {
        return http.post(`${resource}`, payload)
    },
    getProject(projectId,) {
        return http.get(`${resource}/${projectId}`)
    },
    getProjectImage(projectId, step) {
        return http.get(`${resource}/${projectId}/image/${step}`)
    },
    saveProjectImage(projectId, step, payload) {
        return http.post(`${resource}/${projectId}/image/${step}`, payload)
    },
    getProjectMessages(userId) {
        return http.get(`${resource}/user/${userId}/project/message`)
    },
    getEnglishProjectMessages() {
        return http.get(`${resource}/messages`)
    },    
    getProjectPdf(userId, projectId) {
        const conf = {};
        conf.headers = {};
        conf.responseType = 'blob';
        conf.headers['Accept'] = 'application/pdf';
        conf.headers['Content-Type'] = 'application/json';
        return http.get(`${resource}/user/${userId}/project/${projectId}/pdf`, conf)
    },
    getProjectPdfByUserGuest(payload) {
        const conf = {};
        conf.headers = {};
        conf.responseType = 'blob';
        conf.headers['Accept'] = 'application/pdf';
        conf.headers['Content-Type'] = 'application/json';
        return http.post(`${resource}/user/guest/project/pdf`, payload, conf)
    },
    deleteProject(userId, projectId) {
        return http.post(`${resource}/user/${userId}/project/${projectId}/delete`)
    },
}